var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ng-card flex cen-space w-100",class:_vm.handleTransition ? 'transition' : ''},[_c('div',{staticClass:"centent"},[_vm._t("default")],2),_c('div',{staticClass:"handle"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }